import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // استيراد ملف التنسيق الذي يحتوي على كود إخفاء الـ scrollbar
import RealEstateApp from './App'; // استيراد التطبيق الرئيسي 

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <RealEstateApp />
    </React.StrictMode>
  );
} else {
  console.error("لم يتم العثور على عنصر 'root'. تأكد من وجود <div id='root'></div> في ملف index.html");
}